import { MetadataType } from '@aibees/elephant/hooks';
import { PersonProfileBadge } from '@aibees/elephant/types/person';
import { Stack, Typography } from '@mui/material';
import { personProfileBadgeFilterLabelParser } from '../components/filter-tags/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function profileBadgeFilterConfig(): SearchFilterBase {
  return {
    id: 'Profile Badge',
    name: 'Profile Badge',
    icon: 'badge-outline',
    index: 1,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Profile',
        },
      },
    },
    pinned: true,
    sections: { main: 2, more: 1 },
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        layer: 4,
        key: 'profile_badge_contacts_include',
        field: 'profile_badge_contacts_include',
        config: { labelKey: 'label', valueKey: 'value' },
        metadata: {
          color: 'primary',
          icon: 'add-circle-outline',
          placeholder: 'Select Profile Badge',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            enabled: true,
            key: MetadataType.PERSON_PROFILE_BADGE,
          },
          info: <ProfileBadgeFilterInfo />,
        },
        searchKey: 'value',
        utils: {
          tags: { labelFormatter: personProfileBadgeFilterLabelParser },
        },
        treeOptions: PERSON_PROFILE_BADGE_FILTER_OPTIONS,
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        layer: 4,
        key: 'profile_badge_contacts_exclude',
        field: 'profile_badge_contacts_exclude',
        config: { labelKey: 'label', valueKey: 'value' },
        metadata: {
          color: 'error',
          icon: 'block',
          placeholder: 'Select Profile Badge',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            enabled: true,
            key: MetadataType.PERSON_PROFILE_BADGE,
          },
          info: <ProfileBadgeFilterInfo />,
        },
        searchKey: 'value',
        utils: {
          tags: { labelFormatter: personProfileBadgeFilterLabelParser },
        },
        treeOptions: PERSON_PROFILE_BADGE_FILTER_OPTIONS,
      },
      {
        name: 'Include (AND)',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        layer: 4,
        key: 'profile_badge_contacts_all_of',
        field: 'profile_badge_contacts_all_of',
        config: { labelKey: 'label', valueKey: 'value' },
        metadata: {
          color: 'warning',
          icon: 'add-task',
          placeholder: 'Select Profile Badge',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            enabled: true,
            key: MetadataType.PERSON_PROFILE_BADGE,
          },
          info: <ProfileBadgeFilterInfo />,
        },
        searchKey: 'value',
        utils: {
          tags: { labelFormatter: personProfileBadgeFilterLabelParser },
        },
        treeOptions: PERSON_PROFILE_BADGE_FILTER_OPTIONS,
      },
    ],
  };
}

const getPersonProfileBadgeOptions = () =>
  Object.values(PersonProfileBadge).map((personProfileBadge) => ({
    id: personProfileBadge,
    value: personProfileBadge,
    label: personProfileBadgeFilterLabelParser(
      personProfileBadge,
      personProfileBadge
    ),
  }));

export const PERSON_PROFILE_BADGE_FILTER_OPTIONS = [
  getPersonProfileBadgeOptions(),
];

function ProfileBadgeFilterInfo() {
  return (
    <Stack
      direction="column"
      gap={0.25}
      sx={{ maxWidth: (p) => p.spacing(17.25) }}
    >
      <Typography variant="body5">
        Data updated every 30 days, reflecting the past 30-day period.
      </Typography>
      <Typography variant="body5">
        Some accounts may have changed status since then.
      </Typography>
    </Stack>
  );
}
